import { render, staticRenderFns } from "./NewPasswordModal.vue?vue&type=template&id=799cf49c&scoped=true"
import script from "./NewPasswordModal.vue?vue&type=script&lang=js"
export * from "./NewPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./NewPasswordModal.vue?vue&type=style&index=0&id=799cf49c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799cf49c",
  null
  
)

export default component.exports